const items = [
  {
    title: "Capital",
    body: "Early-stage cheques for founders building AI infrastructure, sovereign & physical AI.",
  },
  {
    title: "Market access",
    body: "Hyperscaler marketplaces and co-sell across Microsoft, AWS and GCP, SI partners, and enterprise buyers in the US and GCC. This is how our GP scaled Adfolks into a top Azure partner before its acquisition.",
  },
  {
    title: "An operator in your corner",
    body: "Not quarterly board advice. Deal reviews, procurement navigation, pricing calls, and joint customer meetings, as Investor & Operating Partner.",
  },
];

const WhatWeBring = () => {
  return (
    <section className="py-32 px-4 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="mb-16 space-y-6">
          <div className="inline-block px-6 py-3 bg-primary/10 border-2 border-primary/20 rounded">
            <span className="text-sm font-bold tracking-[0.3em] text-primary uppercase">What We Bring</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-foreground">Three things, in this order</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <div
              key={item.title}
              className={`p-8 bg-secondary border-l-4 ${i % 2 === 0 ? "border-accent" : "border-primary"} hover:shadow-lg transition-shadow`}
            >
              <div className="text-5xl font-black text-muted-foreground/40 mb-4">0{i + 1}</div>
              <h3 className="text-2xl font-black text-foreground mb-3">{item.title}</h3>
              <p className="text-base text-foreground leading-relaxed">{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeBring;